export const OneTimePlans = {
	chats100: {
		name: '100 chats',
		description: 'Paquetes de 100 consultas juridicas en chats/redacciones',
		price: '29.95',
		resources: {
			chat: 100,
		},
		link: '/payments/generate-link?typeOfPayment=one-time&id=chats100',
	},
	analysis5: {
		name: '5 análisis',
		description: 'Paquetes de 5 análisis jurídicos',
		price: '24.95',
		resources: {
			analysis: 5,
		},
		link: '/payments/generate-link?typeOfPayment=one-time&id=analysis5',
	},
	transcription50: {
		name: '50 horas de transcripciones',
		description: 'Paquetes de 50 horas de transcripciones jurídicas',
		price: '19.95',
		resources: {
			transcription: 50 * 60,
		},
		link: '/payments/generate-link?typeOfPayment=one-time&id=transcription50',
	},
} as const

export type ShowOneTimePlan = (typeof OneTimePlans)[keyof typeof OneTimePlans]
